module.exports = __webpack_public_path__ + "img/regionalCase_bg_6_2.938faee5.png";